import React from 'react';
import useStyle from './classManagerBlock.style';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { UploadCSVButton } from '../../../atoms/Buttons/UploadCSVButton';
import { Modal } from '../../../organisms/Modals/Modal';
import FormCreateEleve from '../../../organisms/forms/CreateEleve/FormCreateEleve';
import FormCreateProf from '../../../organisms/forms/CreateProf/FormCreateProf';
import { DownloadCSVButton } from 'components/atoms/Buttons/DownloadCSVButton';
import { CSVEleveResultsTypes } from 'types/user/eleve.def';

interface ClassManagerBlockProps {
  onChange?: (results: CSVEleveResultsTypes) => Promise<void>;
  classeName?: string;
  variant: 'indiv' | 'masse';
  label: string;
}

export const ClassManagerBlock = ({
  onChange,
  classeName,
  variant,
  label
}: ClassManagerBlockProps) => {
  const classes = useStyle();

  const csvElevesDataTemplate = [
    {
      Prenom: 'ex: Julien',
      Nom: 'ex: Blanc'
    }
  ];

  return (
    <div className={classes.root}>
      <p className={classes.text}>{label}</p>
      <div className={classes.line1}>
        {variant === 'masse' && <p className={classes.step}>1</p>}
        {variant === 'indiv' ? (
          <Modal
            modalHead={'Ajoutez un élève 👨🏼‍🎓'}
            triggerButton={
              <div className={classes.fullWidth}>
                <ButtonWithText
                  variant={'primaryBlue'}
                  content={'Ajoutez un élève'}
                  iconColor={'#FFF'}
                  icon={'AddPerson'}
                  onClick={null}
                />
              </div>
            }
          >
            <FormCreateEleve />
          </Modal>
        ) : (
          <DownloadCSVButton
            fileName={`MODELE-${
              classeName
                ? classeName.substring(0, classeName.lastIndexOf('-'))
                : 'CLASSE'
            }`}
            file={csvElevesDataTemplate}
          />
        )}
        {variant === 'masse' && <p className={classes.step}>2</p>}
        {variant === 'indiv' ? (
          <Modal
            modalHead={'Ajoutez un prof 🧑🏻‍🏫'}
            triggerButton={
              <div className={classes.fullWidth}>
                <ButtonWithText
                  variant={'primaryBlue'}
                  content={'Ajoutez un prof'}
                  iconColor={'#FFF'}
                  icon={'AddPerson'}
                  onClick={null}
                />
              </div>
            }
          >
            <FormCreateProf />
          </Modal>
        ) : (
          <UploadCSVButton onChange={onChange} text={'Importez votre .csv'} />
        )}
      </div>
    </div>
  );
};
